'use strict';

function normalizeComponent(template, style, script, scopeId, isFunctionalTemplate, moduleIdentifier
/* server only */
, shadowMode, createInjector, createInjectorSSR, createInjectorShadow) {
  if (typeof shadowMode !== 'boolean') {
    createInjectorSSR = createInjector;
    createInjector = shadowMode;
    shadowMode = false;
  } // Vue.extend constructor export interop.


  var options = typeof script === 'function' ? script.options : script; // render functions

  if (template && template.render) {
    options.render = template.render;
    options.staticRenderFns = template.staticRenderFns;
    options._compiled = true; // functional template

    if (isFunctionalTemplate) {
      options.functional = true;
    }
  } // scopedId


  if (scopeId) {
    options._scopeId = scopeId;
  }

  var hook;

  if (moduleIdentifier) {
    // server build
    hook = function hook(context) {
      // 2.3 injection
      context = context || // cached call
      this.$vnode && this.$vnode.ssrContext || // stateful
      this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext; // functional
      // 2.2 with runInNewContext: true

      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__;
      } // inject component styles


      if (style) {
        style.call(this, createInjectorSSR(context));
      } // register component module identifier for async chunk inference


      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier);
      }
    }; // used by ssr in case component is cached and beforeCreate
    // never gets called


    options._ssrRegister = hook;
  } else if (style) {
    hook = shadowMode ? function () {
      style.call(this, createInjectorShadow(this.$root.$options.shadowRoot));
    } : function (context) {
      style.call(this, createInjector(context));
    };
  }

  if (hook) {
    if (options.functional) {
      // register for functional component in vue file
      var originalRender = options.render;

      options.render = function renderWithStyleInjection(h, context) {
        hook.call(context);
        return originalRender(h, context);
      };
    } else {
      // inject component registration as beforeCreate hook
      var existing = options.beforeCreate;
      options.beforeCreate = existing ? [].concat(existing, hook) : [hook];
    }
  }

  return script;
}

var normalizeComponent_1 = normalizeComponent;

var isOldIE = typeof navigator !== 'undefined' && /msie [6-9]\\b/.test(navigator.userAgent.toLowerCase());

function createInjector(context) {
  return function (id, style) {
    return addStyle(id, style);
  };
}

var HEAD;
var styles = {};

function addStyle(id, css) {
  var group = isOldIE ? css.media || 'default' : id;
  var style = styles[group] || (styles[group] = {
    ids: new Set(),
    styles: []
  });

  if (!style.ids.has(id)) {
    style.ids.add(id);
    var code = css.source;

    if (css.map) {
      // https://developer.chrome.com/devtools/docs/javascript-debugging
      // this makes source maps inside style tags work properly in Chrome
      code += '\n/*# sourceURL=' + css.map.sources[0] + ' */'; // http://stackoverflow.com/a/26603875

      code += '\n/*# sourceMappingURL=data:application/json;base64,' + btoa(unescape(encodeURIComponent(JSON.stringify(css.map)))) + ' */';
    }

    if (!style.element) {
      style.element = document.createElement('style');
      style.element.type = 'text/css';
      if (css.media) style.element.setAttribute('media', css.media);

      if (HEAD === undefined) {
        HEAD = document.head || document.getElementsByTagName('head')[0];
      }

      HEAD.appendChild(style.element);
    }

    if ('styleSheet' in style.element) {
      style.styles.push(code);
      style.element.styleSheet.cssText = style.styles.filter(Boolean).join('\n');
    } else {
      var index = style.ids.size - 1;
      var textNode = document.createTextNode(code);
      var nodes = style.element.childNodes;
      if (nodes[index]) style.element.removeChild(nodes[index]);
      if (nodes.length) style.element.insertBefore(textNode, nodes[index]);else style.element.appendChild(textNode);
    }
  }
}

var browser = createInjector;

/* script */

/* template */
var __vue_render__ = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c("span", {
    staticClass: "circle"
  });
};

var __vue_staticRenderFns__ = [];
__vue_render__._withStripped = true;
/* style */

var __vue_inject_styles__ = function __vue_inject_styles__(inject) {
  if (!inject) return;
  inject("data-v-f90343a4_0", {
    source: "/* stylelint-disable color-no-hex */\n/*\n/* This file defines colors for the whole app, they are mapped to Bootstrap\n/* variables in bootstrap_reset.scss file. Try and reuse similar colors to\n/* avoid a christmas tree look, use http://chir.ag/projects/name-that-color\n/* for color names\n/*\n/* Rule when adding a new color is to prefix it with $color- to help with\n/* autocomplete\n/*\n\n/* *******************\n\n      APP COLORS\n\n********************* */\n/* stylelint-enable color-no-hex */\n/* stylelint-disable color-no-hex */\n/*\n/* This file defines colors for the whole app, they are mapped to Bootstrap\n/* variables in bootstrap_reset.scss file. Try and reuse similar colors to\n/* avoid a christmas tree look, use http://chir.ag/projects/name-that-color\n/* for color names\n/*\n/* Rule when adding a new color is to prefix it with $color- to help with\n/* autocomplete\n/*\n\n/* *******************\n\n      APP COLORS\n\n********************* */\n/* stylelint-enable color-no-hex */\n.circle {\n  position: relative;\n  display: inline-block;\n  vertical-align: middle;\n  width: 20px;\n  height: 20px;\n}\n.circle::before, .circle::after {\n  content: \"\";\n  display: block;\n  width: 20px;\n  height: 20px;\n  position: absolute;\n  top: 0;\n  left: 0;\n  border-radius: 100%;\n  border: 2px solid transparent;\n  box-sizing: border-box;\n}\n.circle::before {\n  border-color: #d5e9fa;\n}\n.circle::after {\n  border-top-color: #2e8fe7;\n  transform-origin: 50% 50%;\n  animation: rotate-spinner 1s infinite linear;\n}\n@keyframes rotate-spinner {\n0% {\n    transform: rotate(0deg);\n}\n100% {\n    transform: rotate(360deg);\n}\n}\n\n/*# sourceMappingURL=Spinner.vue.map */",
    map: {
      "version": 3,
      "sources": ["Spinner.vue", "/home/circleci/project/packages/loading-spinner/Spinner.vue"],
      "names": [],
      "mappings": "AAAA,mCAAmC;AACnC;;;;;;;;;;;;;;uBAcuB;AACvB,kCAAkC;AAClC,mCAAmC;AACnC;;;;;;;;;;;;;;uBAcuB;AACvB,kCAAkC;ACzBlC;EACA,kBAAA;EACA,qBAAA;EACA,sBAAA;EACA,WAAA;EACA,YAAA;AD2BA;ACzBA;EAEA,WAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,mBAAA;EACA,6BAAA;EACA,sBAAA;AD0BA;ACvBA;EACA,qBAAA;ADyBA;ACtBA;EACA,yBAAA;EACA,yBAAA;EACA,4CAAA;ADwBA;ACpBA;AACA;IACA,uBAAA;ADuBE;ACrBF;IACA,yBAAA;ADuBE;AACF;;AAEA,sCAAsC",
      "file": "Spinner.vue",
      "sourcesContent": ["/* stylelint-disable color-no-hex */\n/*\n/* This file defines colors for the whole app, they are mapped to Bootstrap\n/* variables in bootstrap_reset.scss file. Try and reuse similar colors to\n/* avoid a christmas tree look, use http://chir.ag/projects/name-that-color\n/* for color names\n/*\n/* Rule when adding a new color is to prefix it with $color- to help with\n/* autocomplete\n/*\n\n/* *******************\n\n      APP COLORS\n\n********************* */\n/* stylelint-enable color-no-hex */\n/* stylelint-disable color-no-hex */\n/*\n/* This file defines colors for the whole app, they are mapped to Bootstrap\n/* variables in bootstrap_reset.scss file. Try and reuse similar colors to\n/* avoid a christmas tree look, use http://chir.ag/projects/name-that-color\n/* for color names\n/*\n/* Rule when adding a new color is to prefix it with $color- to help with\n/* autocomplete\n/*\n\n/* *******************\n\n      APP COLORS\n\n********************* */\n/* stylelint-enable color-no-hex */\n.circle {\n  position: relative;\n  display: inline-block;\n  vertical-align: middle;\n  width: 20px;\n  height: 20px;\n}\n.circle::before, .circle::after {\n  content: \"\";\n  display: block;\n  width: 20px;\n  height: 20px;\n  position: absolute;\n  top: 0;\n  left: 0;\n  border-radius: 100%;\n  border: 2px solid transparent;\n  box-sizing: border-box;\n}\n.circle::before {\n  border-color: #d5e9fa;\n}\n.circle::after {\n  border-top-color: #2e8fe7;\n  transform-origin: 50% 50%;\n  animation: rotate-spinner 1s infinite linear;\n}\n\n@keyframes rotate-spinner {\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}\n\n/*# sourceMappingURL=Spinner.vue.map */", "<template>\n  <span class=\"circle\" />\n</template>\n\n<style lang=\"scss\">\n@import \"@reciprocity/bootstrap/scss/colors\";\n@import \"@reciprocity/bootstrap/scss/variables\";\n\n.circle {\n  position: relative;\n  display: inline-block;\n  vertical-align: middle;\n  width: 20px;\n  height: 20px;\n\n  &::before,\n  &::after {\n    content: \"\";\n    display: block;\n    width: 20px;\n    height: 20px;\n    position: absolute;\n    top: 0;\n    left: 0;\n    border-radius: 100%;\n    border: 2px solid transparent;\n    box-sizing: border-box;\n  }\n\n  &::before {\n    border-color: mix($color-app-primary, $color-white, 20%);\n  }\n\n  &::after {\n    border-top-color: $color-app-primary;\n    transform-origin: 50% 50%;\n    animation: rotate-spinner 1s infinite linear;\n  }\n}\n\n@keyframes rotate-spinner {\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}\n</style>\n"]
    },
    media: undefined
  });
};
/* scoped */


var __vue_scope_id__ = undefined;
/* module identifier */

var __vue_module_identifier__ = undefined;
/* functional template */

var __vue_is_functional_template__ = false;
/* style inject SSR */

var Spinner = normalizeComponent_1({
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__
}, __vue_inject_styles__, {}, __vue_scope_id__, __vue_is_functional_template__, __vue_module_identifier__, browser, undefined);

//
var script = {
  components: {
    Spinner: Spinner
  },
  props: {
    text: {
      type: String,
      "default": "Loading..."
    }
  }
};

/* script */
var __vue_script__ = script;
/* template */

var __vue_render__$1 = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c("div", {
    staticClass: "loading-spinner-wrap"
  }, [_c("div", {
    staticClass: "spacer"
  }), _vm._v(" "), _c("div", {
    staticClass: "loading-spinner"
  }, [_c("spinner"), _vm._v(" "), _c("div", {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.text))])], 1)]);
};

var __vue_staticRenderFns__$1 = [];
__vue_render__$1._withStripped = true;
/* style */

var __vue_inject_styles__$1 = function __vue_inject_styles__(inject) {
  if (!inject) return;
  inject("data-v-e29d3360_0", {
    source: "/* stylelint-disable color-no-hex */\n/*\n/* This file defines colors for the whole app, they are mapped to Bootstrap\n/* variables in bootstrap_reset.scss file. Try and reuse similar colors to\n/* avoid a christmas tree look, use http://chir.ag/projects/name-that-color\n/* for color names\n/*\n/* Rule when adding a new color is to prefix it with $color- to help with\n/* autocomplete\n/*\n\n/* *******************\n\n      APP COLORS\n\n********************* */\n/* stylelint-enable color-no-hex */\n.loading-spinner-wrap {\n  display: block;\n  position: relative;\n  width: 100%;\n}\n.loading-spinner-wrap .spacer {\n  min-height: 50px;\n}\n.loading-spinner-wrap .loading-spinner {\n  display: block;\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  border: 1px solid #2e8fe7;\n  color: #2e8fe7;\n  border-radius: 4px;\n  padding: 10px;\n  transform: translateY(-50%) translateX(-50%);\n  font-size: 14px;\n  font-weight: bold;\n  cursor: default;\n  white-space: nowrap;\n}\n.loading-spinner-wrap .loading-spinner .text {\n  display: inline-block;\n  margin-left: 5px;\n  vertical-align: middle;\n  text-transform: uppercase;\n  white-space: normal;\n}\n\n/*# sourceMappingURL=LoadingSpinner.vue.map */",
    map: {
      "version": 3,
      "sources": ["LoadingSpinner.vue", "/home/circleci/project/packages/loading-spinner/LoadingSpinner.vue"],
      "names": [],
      "mappings": "AAAA,mCAAmC;AACnC;;;;;;;;;;;;;;uBAcuB;AACvB,kCAAkC;ACalC;EACA,cAAA;EACA,kBAAA;EACA,WAAA;ADXA;ACaA;EACA,gBAAA;ADXA;ACcA;EACA,cAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,yBAAA;EACA,cAZA;EAaA,kBAAA;EACA,aAAA;EACA,4CAAA;EACA,eAAA;EACA,iBAAA;EACA,eAAA;EACA,mBAAA;ADZA;ACcA;EACA,qBAAA;EACA,gBAAA;EACA,sBAAA;EACA,yBAAA;EACA,mBAAA;ADZA;;AAEA,6CAA6C",
      "file": "LoadingSpinner.vue",
      "sourcesContent": ["/* stylelint-disable color-no-hex */\n/*\n/* This file defines colors for the whole app, they are mapped to Bootstrap\n/* variables in bootstrap_reset.scss file. Try and reuse similar colors to\n/* avoid a christmas tree look, use http://chir.ag/projects/name-that-color\n/* for color names\n/*\n/* Rule when adding a new color is to prefix it with $color- to help with\n/* autocomplete\n/*\n\n/* *******************\n\n      APP COLORS\n\n********************* */\n/* stylelint-enable color-no-hex */\n.loading-spinner-wrap {\n  display: block;\n  position: relative;\n  width: 100%;\n}\n.loading-spinner-wrap .spacer {\n  min-height: 50px;\n}\n.loading-spinner-wrap .loading-spinner {\n  display: block;\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  border: 1px solid #2e8fe7;\n  color: #2e8fe7;\n  border-radius: 4px;\n  padding: 10px;\n  transform: translateY(-50%) translateX(-50%);\n  font-size: 14px;\n  font-weight: bold;\n  cursor: default;\n  white-space: nowrap;\n}\n.loading-spinner-wrap .loading-spinner .text {\n  display: inline-block;\n  margin-left: 5px;\n  vertical-align: middle;\n  text-transform: uppercase;\n  white-space: normal;\n}\n\n/*# sourceMappingURL=LoadingSpinner.vue.map */", "<template>\n  <div class=\"loading-spinner-wrap\">\n    <div class=\"spacer\" />\n    <div class=\"loading-spinner\">\n      <spinner />\n      <div class=\"text\">{{ text }}</div>\n    </div>\n  </div>\n</template>\n\n<script>\nimport Spinner from \"./Spinner.vue\";\n\nexport default {\n  components: {\n    Spinner\n  },\n  props: {\n    text: {\n      type: String,\n      default: \"Loading...\"\n    }\n  }\n};\n</script>\n\n<style lang=\"scss\">\n@import \"@reciprocity/bootstrap/scss/variables\";\n\n.loading-spinner-wrap {\n  display: block;\n  position: relative;\n  width: 100%;\n\n  .spacer {\n    min-height: 50px;\n  }\n\n  .loading-spinner {\n    display: block;\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    border: 1px solid $color-app-primary;\n    color: $color-app-primary;\n    border-radius: 4px;\n    padding: 10px;\n    transform: translateY(-50%) translateX(-50%);\n    font-size: 14px;\n    font-weight: bold;\n    cursor: default;\n    white-space: nowrap;\n\n    .text {\n      display: inline-block;\n      margin-left: 5px;\n      vertical-align: middle;\n      text-transform: uppercase;\n      white-space: normal;\n    }\n  }\n}\n</style>\n"]
    },
    media: undefined
  });
};
/* scoped */


var __vue_scope_id__$1 = undefined;
/* module identifier */

var __vue_module_identifier__$1 = undefined;
/* functional template */

var __vue_is_functional_template__$1 = false;
/* style inject SSR */

var LoadingSpinner = normalizeComponent_1({
  render: __vue_render__$1,
  staticRenderFns: __vue_staticRenderFns__$1
}, __vue_inject_styles__$1, __vue_script__, __vue_scope_id__$1, __vue_is_functional_template__$1, __vue_module_identifier__$1, browser, undefined);

module.exports = LoadingSpinner;
